import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import uploadImg from "../../../images/cloud-upload-regular-240.png";
import fileDefault from "../../../images/file-blank-solid-240.png";
import fileExcel from "../../../images/excel.png";
import "./DropFile.css";
import { ThreeCircles } from "react-loader-spinner";

export const ImageConfig = {
  default: fileDefault,
  xlsx: fileExcel,
  xls: fileExcel,
};

const DropFileInput = (props) => {
  const { disabled = false } = props;
  const wrapperRef = useRef(null);

  const [fileList, setFileList] = useState([]);

  const onDragEnter = () => {
    if (disabled) return;
    wrapperRef.current.classList.add("dragover");
  };

  const onDragLeave = () => {
    if (disabled) return;
    wrapperRef.current.classList.remove("dragover");
  };

  const onDrop = () => {
    if (disabled) return;
    wrapperRef.current.classList.remove("dragover");
    wrapperRef.current.classList.add("dropped");
  };

  const onFileDrop = (e) => {
    if (disabled) return;
    const newFile = e.target.files[0];
    if (newFile) {
      let updatedList = [...fileList, newFile];
      if (props && props.fileLimit && props.fileLimit === "single") {
        updatedList = [newFile];
        setFileList(updatedList);
      } else {
        setFileList(updatedList);
      }
      props.onFileChange(updatedList, e);
    }
  };

  useEffect(() => {
    if (!props.uploading) {
      setFileList([]);
    }
  }, [props.uploading]);

  const fileRemove = (file) => {
    if (disabled) return;
    const updatedList = [...fileList];
    updatedList.splice(fileList.indexOf(file), 1);
    setFileList(updatedList);
    props.onFileChange(updatedList);
  };

  return (
    <>
      <div
        ref={wrapperRef}
        className={`drop-file-input ${disabled ? "drop-file-input--disabled" : ""}`}  // Add disabled class
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        {props.uploading && fileList.length > 0 ? (
          fileList.map((item, index) => (
            <div key={index} className="drop-file-input__label">
              <div className="uploading-animation">
                <div>
                  <ThreeCircles
                    height="30"
                    width="30"
                    color="#4fa94d"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                    ariaLabel="three-circles-rotating"
                    outerCircleColor="var(--theme1_tertiary)"
                    innerCircleColor="var(--theme1_secondary)"
                    middleCircleColor="var(--theme1_primary)"
                  />
                </div>
                <div>
                  <p>Uploading your file...</p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="drop-file-input__label">
            <img src={uploadImg} alt="" />
            <p>{disabled ? "Upload disabled" : (props.message || "Drag and drop your file here")}</p>
          </div>
        )}

        <input 
          type="file" 
          value="" 
          onChange={onFileDrop} 
          accept={props.accept} 
          disabled={disabled}
        />
      </div>
    </>
  );
};

DropFileInput.propTypes = {
  onFileChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default DropFileInput;